export enum InvoiceNumberingMode {
  Sequential = 'sequential',
  Manual = 'manual',
}
